import {FC, Suspense} from 'react';

import {FloatingAlertLazy} from 'app/core/floatingAlert/basic/lazy';
import {useGemStore} from 'app/gemStore';

export const FloatingAlertLoader: FC = () => {
    const renderBasicFloatingAlert = useGemStore((state) => state.floatingAlert.some((alert) => !alert.mode || alert.mode === 'BASIC'));

    if (renderBasicFloatingAlert) {
        return (
            <Suspense>
                <FloatingAlertLazy />
            </Suspense>
        );
    }
};
